<app-perfil-shell [userName]="userName" [subtitle]="copy.shell.subtitle" [ctaLabel]="ctaLabel"
  [ctaDisabled]="!puedeSolicitarCredito" [showSecurityBanner]="true" [hideSiteFooter]="true" [stickyHeader]="true"
  [skipFooterCms]="true" (ctaClick)="onSolicitarCredito()">
  <div class="perfil-hub">
    <div class="perfil-hub__layout" [class.perfil-hub__layout--con-aside]="alianzas.length > 0">
      <section class="perfil-hub__panel" aria-labelledby="perfil-hub-title">
        <app-perfil-progress-general [titulo]="hubTitle" [progreso]="progresoGlobal"
          [seccionesCompletas]="seccionesCompletas" [totalSecciones]="secciones.length"></app-perfil-progress-general>

        <div class="perfil-hub__list" role="list">
          @for (seccion of secciones; track seccion.id) {
          <div role="listitem">
            <app-perfil-section-card [titulo]="seccion.titulo" [icon]="seccion.icon" [estado]="seccion.estado"
              [progreso]="seccion.progreso" [checkpoints]="seccion.checkpoints" [disabled]="seccion.disabled"
              [actionLabel]="actionLabelFor(seccion)" [elementId]="'btn-perfil-hub-' + seccion.id"
              (actionClick)="onSeccionAction(seccion)"></app-perfil-section-card>
          </div>
          }
        </div>
      </section>
      @if (alianzas.length) {
      <aside class="perfil-hub__aside" aria-label="Aliados estratégicos">
        <app-perfil-alianza-hub-card [alianzas]="alianzas"></app-perfil-alianza-hub-card>
      </aside>
      }
    </div>

    <section class="perfil-hub__solicitudes" aria-labelledby="perfil-hub-solicitudes">
      <div class="perfil-hub__solicitudes-text">
        <h2 id="perfil-hub-solicitudes" class="perfil-hub__solicitudes-title">
          {{ copy.hub.solicitudesTitle }}
        </h2>
        <p class="perfil-hub__solicitudes-desc">{{ copy.hub.solicitudesEmpty }}</p>
      </div>
      <button type="button" class="perfil-hub__cta perfil-hub__cta--outline" id="btn-perfil-completar-solicitudes"
        [disabled]="perfilCompleto" (click)="onCompletarPerfil()">
        {{ copy.hub.ctaCompletarPerfil }}
      </button>
    </section>
  </div>
</app-perfil-shell>

<app-perfil-intro-modal [open]="introModalOpen" [seccionId]="introSeccionId" [segmento]="segmentoIntro"
  [juridica]="isJuridica" (closed)="closeIntroModal()"
  (completarDatos)="onIntroCompletarDatos($event)"></app-perfil-intro-modal>

<app-perfil-enviar-modal [open]="enviarModalOpen" [enviando]="enviando" (closed)="closeEnviarModal()"
  (revisar)="onEnviarRevisar()" (enviar)="onEnviarSolicitud()"></app-perfil-enviar-modal>
